import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { SignatureStatsActive } from './SignatureStatsActive';
import { SignatureStatsClosed } from './SignatureStatsClosed';

const SignatureStatsInner: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker },
	} = usePetitionDetailsPageUserData();

	// MobileActionButton renders these above the share CTA instead — except for a decision maker,
	// whose respond action short-circuits that branch before it reaches the status.
	if (status === 'CLOSED') {
		return decisionMaker ? <SignatureStatsClosed /> : null;
	}

	if (status === 'VICTORY') {
		return null;
	}

	return <SignatureStatsActive />;
};

export const SignatureStatsMobile: React.FC<EmptyProps> = () => {
	return (
		<div className="my-4" data-qa="signature-stats-section">
			<SignatureStatsInner />
		</div>
	);
};
